import React, { Fragment } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Form, Field } from 'redux-form'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Button from 'components/common/Button/Button'
import { Input } from 'components/common/FormElements/Input'
import Columns from 'components/common/Columns/Columns'
import { normalizePhoneNumber } from 'helpers/phone-number'
import { PHONE_MASK } from 'constant'
import Helmet from 'react-helmet'
import { FLEET_SERVICES_OG_TITLE, FLEET_SERVICES_OG_DESCRIPTION } from '../constants'


const OGHelmet = () =>
  <Helmet>
    <meta property="og:title" content={ FLEET_SERVICES_OG_TITLE } />
    <meta property="og:description" content={ FLEET_SERVICES_OG_DESCRIPTION } />
  </Helmet>


const BOTFleetServicesContactUsForm = ({
  handleSubmit,
  formViewModel: {
    name,
    address,
    city,
    state,
    zipCode,
    email,
    phone,
    phoneExtension,
    bestTimeToCall,
    numberOfVehicles,
    typeOfCompany
  },
  normalizeValue,
  error
}) =>
  <Wrapper>
    <OGHelmet />
    <StyledForm onSubmit={ handleSubmit }>
      <StyledColumns adaptive width="50% 50%">
        <Fragment>
          <StyledField
            { ...name }
            component={ Input } />
          <StyledField
            { ...address }
            component={ Input } />
          <StyledField
            { ...city }
            component={ Input } />
          <StyledField
            { ...state }
            component={ Input }
            normalize={ normalizeValue } />
          <StyledField
            { ...zipCode }
            component={ Input } />
        </Fragment>
        <Fragment>
          <StyledField
            { ...email }
            hasError={ error }
            component={ Input } />
          <StyledField
            { ...phone }
            mask={ PHONE_MASK }
            normalize={ normalizePhoneNumber }
            component={ Input } />
          <StyledField
            { ...phoneExtension }
            component={ Input } />
          <StyledField
            { ...bestTimeToCall }
            component={ Input } />
          <StyledField
            { ...numberOfVehicles }
            component={ Input } />
          <StyledField
            { ...typeOfCompany }
            component={ Input } />
        </Fragment>
      </StyledColumns>
      <StyledButton
        full="mobile">
        Submit Request
      </StyledButton>
    </StyledForm>
  </Wrapper>

export default BOTFleetServicesContactUsForm

BOTFleetServicesContactUsForm.propTypes = {
  error: PropTypes.string,
  formatSubjectField: PropTypes.func,
  formViewModel: PropTypes.shape({
    name: PropTypes.shape(),
    address: PropTypes.shape(),
    city: PropTypes.shape(),
    state: PropTypes.shape(),
    zipCode: PropTypes.shape(),
    email: PropTypes.shape(),
    phone: PropTypes.shape(),
    phoneExtension: PropTypes.shape(),
    bestTimeToCall: PropTypes.shape(),
    numberOfVehicles: PropTypes.shape(),
    typeOfCompany: PropTypes.shape()
  }),
  handleSubmit: PropTypes.func,
  normalizeValue: PropTypes.func
}

const Wrapper = styled.div`
  margin: 0 auto 70px;
  ${Mixin.responsive('padding', '0', '0 20px')}
`

const StyledForm = styled(Form)`
  margin: 0 auto;
  ${Mixin.responsive('width', '620px', '100%')}
`
const StyledField = styled(Field)`
  width: 302px;
  margin-bottom: 30px;
  ${Media.mobile`
    display: block;
    width: 100%
  `}
`

const StyledColumns = styled(Columns) `
  [data-column] {
    ${Mixin.responsive('padding-right', '15px', '0')}
  }

  ${Media.mobile`
    & [data-error-message] {
      position: static;
      display: inline-block;
      margin-top: 7px;
    }
  `}
`

const StyledButton = styled(Button)`
  ${Media.desktop`
    float: right;
  `}
`
